import React from 'react';

import { bemCssModules, getTestId } from '@utils';

import Illustration, { TIllustration } from '@components/Illustration';
import MainLayout, { TMainLayout } from '@layouts/MainLayout';

import style from './Restriction.scss';

const cn = bemCssModules(style, 'Restriction');
const ti = getTestId('Restriction');

export type TRestriction = {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  button?: React.ReactNode;
  images?: TIllustration['images'];
  classNameLayout?: string;
  closeButton?: TMainLayout['closeButton'];
  backButton?: TMainLayout['backButton'];
  onLogoClick?: TMainLayout['onLogoClick'];
  isBlockedPage?: TMainLayout['isBlockedPage'];
  isHideLinks?: boolean;
  testId?: string;
};

export const Restriction: CustomFC<TRestriction> = props => {
  const {
    className,
    title,
    subtitle,
    images,
    button,
    children,
    classNameLayout,
    closeButton,
    backButton,
    onLogoClick,
    isBlockedPage,
    testId,
    isHideLinks,
  } = props;

  return (
    <MainLayout
      backButton={backButton}
      closeButton={closeButton}
      isHideLinks={isHideLinks}
      onLogoClick={onLogoClick}
      className={cn('layout', [classNameLayout])}
      isBlockedPage={isBlockedPage}
    >
      <div className={cn(null, [className])} data-testid={ti(testId)}>
        <div className={cn('container')}>
          {title && <div className={cn('title')}>{title}</div>}
          {subtitle && <div className={cn('subtitle')}>{subtitle}</div>}
          {children}
          {button && <div className={cn('button')}>{button}</div>}
        </div>
        {images && <Illustration className={cn('illustration')} images={images} />}
      </div>
    </MainLayout>
  );
};

export default Restriction;
